<li
  *ngIf="product"
  class="flex flex-col md:flex-row items-center w-full"
  (click)="cliqueAdsCard(); trackClickSmartHint()"
  (keydown.enter)="cliqueAdsCard(); trackClickSmartHint()"
  (keydown.space)="cliqueAdsCard(); trackClickSmartHint(); $event.preventDefault()"
  [attr.aria-label]="'Produto ' + product.descricao +
    (product.em_oferta ? ', em oferta' : '') +
    (product.disponivel ? ', disponível' : ', indisponível')"
>
  <div class="w-[352px] flex">
    <div class="vip-product-image-wrapper w-full flex-none">
      <vip-image
        class="cursor-pointer"
        [alt]="product.descricao"
        [attr.data-cy]="'item_product_' + product.id + '_image'"
        [imageUrl]="product.imagem || ''"
        (click)="productClick.emit(product)"
      ></vip-image>
    </div>

    <div
      class="vip-product-description-wrapper w-full pr-6 flex flex-col justify-center"
    >
      <span
        class="text-tiny patrocinado-color"
        *ngIf="
          product.anunciado && product.urls_eventos_ads && product.disponivel
        "
      >
        Patrocinado
      </span>

      <p
        class="text-sm vip-color-second-default cursor-pointer w-full md:w-[165px]"
        [attr.title]="product.descricao"
        [attr.tabindex]="opened ? 0 : -1"
        (click)="productClick.emit(product)"
        (keydown)="handleProductKeyboardEntry($event, product)"
      >
        {{ product.descricao }}
      </p>

      <vip-tag
        *ngIf="product.em_oferta && product.disponivel"
        class="block mt-1 cursor-pointer"
        [classeOferta]="product.oferta?.classe_oferta"
        [label]="product.oferta?.nome || ''"
        [tag]="product.oferta?.tag"
        (tagClick)="tagClick.emit()"
      ></vip-tag>
    </div>

    <div
      class="vip-product-price-wrapper w-full md:w-[91px] flex items-center md:justify-start"
    >
      <span
        class="text-xs vip-color-primary-main mr-2 cursor-pointer"
        [attr.data-cy]="'item_product_' + product.id + '_preco'"
        tabindex="0"
        >{{ produtoPreco }}</span
      >

      @if (exibeTag) {
        <vip-tag
          [attr.data-cy]="'item_product_percent_' + product.id + '_tag'"
          [classeOferta]="product.oferta?.classe_oferta"
          [type]="product.possui_unidade_diferente ? 'ex-small' : 'small'"
          [label]="percentOferta"
          (tagClick)="tagClick.emit()"
        ></vip-tag>
      }
    </div>
  </div>

  <div class="w-full justify-end flex">
    <div
      class="vip-product-buttons-wrapper w-full md:w-[105px] flex flex-col justify-end"
    >
      <vip-spin
        *ngIf="!isBrinde"
        size="x-small"
        [attr.data-cy]="'item_product_' + product.id + '_spin'"
        [confimDeletion]="true"
        [max]="product | quantidadeMaximaProduto"
        [quantityUnity]="product | quantidadeUnidadeDiferenteProduto"
        [quantity]="product | quantidadeProduto: produtosNoCarrinho"
        [subTitleModalConfimDeletion]="product.descricao"
        [unityMeasureAbbreviation]="product.unidade_sigla"
        [large]="true"
        [focusable]="opened"
        (changed)="handleClickSpinChange($event)"
        (openedConfirmDeleteModal)="openedConfirmDeleteModal.emit($event)"
        (adsClick)="cliqueAdsCard()"
        [seletorDePesoHabilitado]="product.habilitar_seletor_unidade_peso"
        [produto]="product"
        [tipoDeMedida]="product.seletor_medida_id"
        (trackClick)="trackClickSmartHint()"
      ></vip-spin>
    </div>
  </div>
</li>
